<div class="content">
  <div class="content-outlet">
    <section class="container">
      <div class="logoff">
        <p class="logoff-message">Sua sessão será encerrada e você precisará fazer login novamente.</p>
        <div class="logoff-body d-flex justify-center align-center">
          <ng-container>
            <app-svg-icon src="assets/icons/circle-xmark.svg "
                          color="accentGray"
                          width="75px"
                          height="65px">
            </app-svg-icon>
          </ng-container>
        </div>
        <div class="logoff-actions actions d-flex">
          <button class="actions-btn"
                  routerLink="/esteira-apuracao">
            Início
          </button>
          <button class="actions-btn btn-danger"
                  (click)="logout()">
            Sair
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
